<template>
  <div
    v-if="applicationReady && componentReady"
    class="questionnaire"
  >
    <div class="questionnaire-top">
      <b-row>
        <b-col
          v-if="!formSubmitted"
          cols="12"
        >
          <b-row>
            <b-col
              cols="12"
              md="6"
              offset-md="3"
              class="text-center pb-4"
            >
              <h1>
                Enter date and time of exit
              </h1>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-row class="question-errors">
                <b-col
                  v-if="$v.formAnswers.enterDateOfExit.$error || $v.formAnswers.enterTimeOfExit.$error"
                  cols="12"
                  class="pb-3"
                >
                  <div
                    class="invalid-feedback"
                  >
                    <h3>Date and time of exit is required</h3>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-form @submit.prevent>
            <b-row>
              <b-col cols="12">
                <b-form-row class="question-answer">
                  <b-col
                    cols="12"
                    md="3"
                    class="pb-3"
                    offset-md="3"
                  >
                    <b-form-datepicker
                      id="example-datepicker"
                      v-model="formAnswers.enterDateOfExit"
                      class="mb-2"
                      :max="max"
                      :date-format-options="dateFormatOptions"
                    />
                  </b-col>

                  <b-col
                    cols="12"
                    md="3"
                    class="pb-3"
                  >
                    <b-form-timepicker
                      v-model="formAnswers.enterTimeOfExit"
                      locale="en"
                    />
                  </b-col>
                </b-form-row>

                <b-row v-if="hasTemperatureQuestion">
                  <b-col cols="12">
                    <b-row>
                      <b-col
                        cols="12"
                        :class="questionClasses"
                      >
                        <h1>
                          {{ questionTemperature.question }}
                        </h1>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12">
                        <b-row class="question-errors">
                          <b-col
                            v-if="$v.formAnswers.$error"
                            cols="12"
                            class="pb-3"
                          >
                            <div
                              v-if="!$v.formAnswers.temperature.required"
                              class="invalid-feedback"
                            >
                              <h3>Temperature is required</h3>
                            </div>

                            <div
                              v-if="!$v.formAnswers.temperature.decimal"
                              class="invalid-feedback"
                            >
                              <h3>Temperature must be a decimal</h3>
                            </div>

                            <div
                              v-if="!$v.formAnswers.temperature.between"
                              class="invalid-feedback"
                            >
                              <h3>Enter a temperature between {{ lowTemp }}&deg; and {{ highTemp }}&deg; F to continue</h3>
                            </div>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col
                        v-if="questionTemperature.subQuestion"
                        cols="12"
                        class="sub-question"
                      >
                        <h5>
                          {{ questionTemperature.subQuestion }}
                        </h5>
                      </b-col>
                    </b-row>

                    <b-form-row class="question-answer">
                      <b-col
                        cols="12"
                        md="6"
                        class="pb-3"
                        offset-md="3"
                      >
                        <!-- <cleave
                      v-model="formAnswers.temperature"
                      :options="masks.temperature"
                      class="form-control form-control-lg"
                      step=".1"
                      autofocus="autofocus"
                      placeholder="98.6"
                    /> -->
                        <b-form-input
                          size="lg"
                          type="number"
                          v-model="formAnswers.temperature"
                          step=".1"
                          placeholder="i.e. 98.6"
                          onfocus="this.placeholder = ''"
                          onblur="this.placeholder = 'i.e. 98.6'"
                          @keyup.enter="submitForm"
                        />
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          v-if="formSubmitted"
          cols="12"
          class="screening-complete"
        >
          <b-row>
            <b-col
              cols="12"
              class="screening-complete-title"
            >
              <span class="success-message exit">
                <h1>
                  Screening Complete!
                </h1>
              </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <div class="questionnaire-bottom">
      <b-row>
        <b-col cols="12">
          <b-form>
            <b-form-row class="justify-content-center no-gutters">
              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
                <b-button
                  @click="previousPage"
                  :disabled="true"
                  class="btn-green btn-nav"
                >
                  <b-icon-caret-left-fill />
                </b-button>
              </b-col>

              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-3"
              >
                <b-button
                  @click.stop.prevent="submitForm"
                  class="btn-green btn-nav"
                >
                  Submit
                </b-button>
              </b-col>

              <b-col
                v-if="!formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-1"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
                <b-button
                  @click="goHome"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/home-icon.png"
                    class="screening-icon"
                  >
                </b-button>
              </b-col>

              <b-col
                v-if="formSubmitted"
                cols="6"
                sm="4"
                class="pb-3 question-navigation order-md-2"
              >
                <b-button
                  @click="logout"
                  class="btn-green btn-nav"
                >
                  <img
                    src="../assets/log-out-icon-white.png"
                    class="icon-with-text"
                  >
                  Log out
                </b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </div>

    <b-modal
      v-model="showFailedScreeningModal"
      id="failed-screening"
      modal-class="failed-screening"
      centered
      no-close-on-esc
      hide-header
      hide-footer
    >
      <div class="failed-screening-icon">
        <img
          src="../assets/warning-icon.png"
          class="icon"
        >
      </div>

      <p class="my-4 text-center">
        Confirm {{ selectedUser.itemName }} {{ failureModalDescription }}
      </p>

      <b-row>
        <b-col
          cols="12"
          class="pb-3 text-left"
        >
          <b-button
            variant="green"
            class="failed-screening-option"
            @click.stop.prevent="submitFormFailure"
          >
            Confirm &raquo;
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col
          cols="12"
        >
          <b-button
            variant="green"
            class="failed-screening-option"
            @click="showFailedScreeningModal = !showFailedScreeningModal"
          >
            &laquo; Go back
          </b-button>
        </b-col>
      </b-row>

      <template v-slot:modal-header-close>
        &nbsp;
      </template>
    </b-modal>
  </div>
</template>

<script>
import { LOW_TEMP, HIGH_TEMP } from '../store/modules/form-types'
import { mapGetters } from 'vuex'
import { between, decimal, required } from 'vuelidate/lib/validators'
import mixin from '../mixins/forms.js'
// import Cleave from 'vue-cleave-component'

export default {
  middleware: 'auth',
  name: 'ExitScreeningOhio',
  mixins: [mixin],
  // components: {
  //   Cleave
  // },
  data () {
    return {
      formAnswers: {
        enterDateOfExit: '',
        enterTimeOfExit: '',
        temperature: ''
      }
    }
  },
  validations () {
    if (this.hasTemperatureQuestion) {
      return {
        formAnswers: {
          enterDateOfExit: {
            required
          },
          enterTimeOfExit: {
            required
          },
          temperature: {
            required,
            decimal,
            between: between(LOW_TEMP, HIGH_TEMP)
          }
        }
      }
    } else {
      return {
        formAnswers: {
          enterDateOfExit: {
            required
          },
          enterTimeOfExit: {
            required
          }
        }
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapGetters({
      masks: 'forms/masks'
    }),
    componentReady () {
      if (this.loggedIn) {
        return this.currentQuestionnaire !== undefined && this.questions !== undefined
      }
      return false
    },
    questionDate () {
      if (this.componentReady) {
        return this.findQuestionBySection('enterDateOfExit')
      }
      return {}
    },
    questionTime () {
      if (this.componentReady) {
        return this.findQuestionBySection('enterTimeOfExit')
      }
      return {}
    },
    questionTemperature () {
      if (this.componentReady) {
        return this.findQuestionBySection('temperature')
      }
      return {}
    },
    hasTemperatureQuestion () {
      if (this.componentReady) {
        return this.questionHasSection('temperature')
      }
      return false
    }
  },
  methods: {
    async init () {
      await this.setCurrentDateAndTime('exit')
      await this.setCurrentPage(1)
      await this.isSingleStep()
    },
    submitForm () {
      this.$v.formAnswers.$touch()
      if (!this.$v.formAnswers.$invalid) {
        this.setFormSubmitted(!this.formSubmitted)
        this.addFormResults(this.answersById)
      }
    },
    submitFormFailure () {
      this.setFailedScreening(true)
      this.showFailedScreeningModal = !this.showFailedScreeningModal
      this.submitForm()
    }
  }
}
</script>

<style scoped lang="scss">
.questionnaire-bottom {
  // height: 30vh;
  text-align: center;
}
</style>
